// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"40":"2f167be1","171":"e1e49013","349":"c8b34b24","432":"d2e1e076","845":"53a87d5b","870":"86b63b0c"}[chunkId] + ".chunk.js";
};